import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { isNativePlatform } from '@/utils/nativePlugins';

/**
 * Hook that listens for deep links and navigates within the app.
 * Intercepts godyspo.com URLs and routes them through React Router.
 */
export const useAppUrlListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativePlatform()) return;

    let listenerHandle: { remove: () => Promise<void> } | null = null;

    const setupListener = async () => {
      listenerHandle = await App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        console.log('[DeepLink] App opened with URL:', event.url);
        
        try {
          const url = new URL(event.url);
          const path = url.pathname + url.search + url.hash;
          
          console.log('[DeepLink] Navigating to:', path);
          navigate(path);
        } catch (error) {
          console.error('[DeepLink] Failed to parse URL:', error);
        }
      });
    };

    setupListener();

    return () => {
      if (listenerHandle) {
        listenerHandle.remove();
      }
    };
  }, [navigate]);
};
